import router from '@/router';
import { store } from '../store/store';
import { EventReportingStore } from '../service/getData';
import md5 from 'js-md5';

// 浏览器指纹，缓存localStorage key
const EVENT_REPORT_KEY = 'event-report-key-1';

let BaseParams = {
	business: {},
	common: {},
	page: {},
	ts: null
};

function getOS() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// 检测操作系统
	if (/windows phone/i.test(userAgent)) {
		return 'Windows Phone';
	}
	if (/win/i.test(userAgent)) {
		return 'Windows';
	}
	if (/android/i.test(userAgent)) {
		return 'Android';
	}
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		return 'IOS';
	}
	if (/Macintosh|Mac OS X/.test(userAgent)) {
		return 'MacOS';
	}

	return 'h5_m';
}

let mid = window.localStorage.getItem(EVENT_REPORT_KEY) || generateBrowserFingerprint();
let os = getOS(); //android/ios/web/pc/h5_m(m站)

// 生成浏览器指纹 返回MD5结果
function generateBrowserFingerprint() {
	const data = [
		new Date().getTime(),
		navigator.maxTouchPoints,
		navigator.hardwareConcurrency,
		navigator.userAgent,
		screen.colorDepth,
		Array.prototype.map
			.call(navigator.plugins, function(plugin) {
				return [plugin.name, plugin.description];
			})
			.join(',')
	];

	const fingerprint = md5(data.join('###'));
	window.localStorage.setItem(EVENT_REPORT_KEY, fingerprint);

	return fingerprint;
}

/**
 * 埋点上报
 * @param {BaseParams} params common不需要传递，如要修改，请在底层添加字段
 * @returns
 */
export const EventReport = (params = {}) => {
	let uid = store.state.userInfo.userId || store.state.userInfo.mobile || '';
	let ts = new Date().getTime();
	let sign = md5('XUBEIEVENT' + ts);
	let headers = {
		'Content-Type': 'multipart/form-data',
		ts,
		sign
	};
	params.common = {
		ch: store.state.virtualChannel || store.state.channel || store.state.businessNo,
		mid,
		uid,
		os
	};
	params.ts = ts;
	let formData = new FormData();
	formData.append('jsonData', JSON.stringify(params));
	return EventReportingStore(formData, headers);
};



// WEBPACK FOOTER //
// ./src/util/eventReport.js